import { last } from 'ramda'
import { graphql } from 'babel-plugin-relay/macro'
import { readInlineData } from 'relay-runtime'

import type { utils_PaymentOption$key } from './__generated__/utils_PaymentOption.graphql'

export const getBestInstallmentData = (
  paymentOptionRef: utils_PaymentOption$key
) => {
  const paymentMethod = readInlineData(
    graphql`
      fragment utils_PaymentOption on PaymentOption @inline {
        total {
          amount
        }
        installments {
          edges {
            node {
              interestRate
              total {
                amount
              }
              value {
                amount
              }
            }
          }
        }
      }
    `,
    paymentOptionRef
  )

  const installmentsWithoutInterest =
    paymentMethod.installments.edges.filter(
      (installment) => installment.node.interestRate === 0
    ) ?? []

  const installments =
    installmentsWithoutInterest.length > 1
      ? installmentsWithoutInterest
      : paymentMethod.installments.edges

  return {
    total: paymentMethod.total.amount,
    installments,
    hasInterestRate: last(installments)?.node.interestRate !== 0,
    lastInstallmentValue: last(installments)?.node.value.amount ?? 0,
  }
}
